import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { Modal, Button } from 'antd';
import PropTypes from 'prop-types';

const CommonDialog = forwardRef(({
  trigger,
  title,
  width = 720,
  children,
  onCancel,
  destroyOnClose = true,
  maskClosable = false,
  keyboard = true,
  centered = true,
  cancelButton = true,
}, ref) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleCancel = () => {
    setOpen(false);
    onCancel?.();
  };

  useImperativeHandle(ref, () => ({
    closeDialog: handleCancel,
    openDialog: handleOpen
  }));

  const childrenArray = React.Children.toArray(children);
  const footerComponent = childrenArray.find(
    child => React.isValidElement(child) && 
    (child.type === CommonDialog.Footer || child.type?.displayName === 'Footer')
  );
  const otherComponents = childrenArray.filter(
    child => !React.isValidElement(child) || 
    (child.type !== CommonDialog.Footer && child.type?.displayName !== 'Footer')
  );

  return (
    <>
      {trigger && (
        <div onClick={handleOpen}>
          {trigger}
        </div>
      )}
      <Modal
        className='max-h-[90vh] overflow-y-auto'
        title={title}
        open={open}
        width={width}
        onCancel={handleCancel}
        footer={null}
        destroyOnClose={destroyOnClose}
        maskClosable={maskClosable}
        keyboard={keyboard}
        centered={centered}
      >
        <div className='max-h-[80vh] overflow-y-auto'>
        {otherComponents}
          {footerComponent || (
            cancelButton && (
              <div style={{ marginTop: 24, textAlign: 'right' }}>
                <Button onClick={handleCancel}>Cancel</Button>
              </div>
            )
          )}
        </div>
      </Modal>
    </>
  );
});

const Footer = ({ children }) => children;

Footer.displayName = 'Footer';
CommonDialog.displayName = 'CommonDialog';

CommonDialog.Footer = Footer;

CommonDialog.propTypes = {
  trigger: PropTypes.node.optional,
  children: PropTypes.node.isRequired,
  title: PropTypes.node,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onCancel: PropTypes.func,
  destroyOnClose: PropTypes.bool,
  maskClosable: PropTypes.bool,
  keyboard: PropTypes.bool,
  centered: PropTypes.bool,
};

export default CommonDialog;
